import React from 'react';
import Link from 'next/link';
import { useRouter } from 'next/navigation';
import { cn } from '@/utils/cn';
import Button from '../Button';
import Icon from '../Icon';
import ButtonLabel from '../Typography/ButtonLabel';

function SectionCTA({
  sectionRedirectUrl,
  className = '',
  hideButton = false,
}) {
  const router = useRouter();

  const handleClickUrl = (e, url) => {
    e.stopPropagation();

    if (!url) return null;

    if (url?.en?.type === 'web') {
      router.push(url?.en?.url);
    } else if (url?.en?.type === 'external') {
      window.open(url?.en?.url, '_blank');
    }
  };

  return (
    <div className={cn('flex justify-center lg:justify-start', className)}>
      {!hideButton &&
      sectionRedirectUrl?.en?.url &&
      sectionRedirectUrl?.en?.text ? (
        <>
          {sectionRedirectUrl?.en?.type === 'web' && (
            <Link
              prefetch={false}
              aria-label="Go to section"
              href={sectionRedirectUrl?.en?.url ?? '#'}
              passHref
            >
              <Button
                type="primary"
                className="bg-white/60 w-full max-w-max lg:max-w-max h-[24px] lg:h-[40px] gap-[6px] py-4 lg:gap-2 px-16 lg:px-24 lg:backdrop-blur-[50px]"
                onClick={(e) => handleClickUrl(e, sectionRedirectUrl?.en?.url)}
              >
                <ButtonLabel
                  label={sectionRedirectUrl?.en?.text}
                  className="text-xs lg:text-base text-tealgreen font-bold lg:font-semibold whitespace-nowrap"
                />
                <Icon
                  type="angle-down"
                  color="#00685F"
                  className="size-[16px] lg:size-[20px] -rotate-90"
                />
              </Button>
            </Link>
          )}
          {sectionRedirectUrl?.en?.type === 'external' && (
            <a
              href={sectionRedirectUrl?.en?.url ?? '#'}
              target="_blank"
              rel="noopener noreferrer"
            >
              <Button
                type="primary"
                className="bg-white/60 w-full max-w-max lg:max-w-max h-[24px] lg:h-[40px] gap-[6px] lg:gap-2 py-4 px-16 lg:px-24 lg:backdrop-blur-[50px]"
                onClick={(e) => handleClickUrl(e, sectionRedirectUrl?.en?.url)}
              >
                <ButtonLabel
                  label={sectionRedirectUrl?.en?.text}
                  className="text-xs lg:text-base text-tealgreen font-bold lg:font-semibold whitespace-nowrap"
                />
                <Icon
                  type="angle-down"
                  color="#00685F"
                  className="size-[16px] lg:size-[20px] -rotate-90"
                />
              </Button>
            </a>
          )}
        </>
      ) : null}
    </div>
  );
}

export default SectionCTA;
